function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @memberOf module:wdh-feature-b2b
 */
var SelectList = /*#__PURE__*/function (_React$Component) {
  function SelectList(props) {
    var _this;
    _classCallCheck(this, SelectList);
    _this = _callSuper(this, SelectList, [props]);
    _this.state = {
      hasValue: _this.props.selectedValue !== '-1' && _this.props.selectedValue !== '',
      isOpen: false,
      isListElementRendered: false
    };
    return _this;
  }

  /**
  * The component properties were received and component state will be synced with the change
  * @param {Object} nextProps The updated properties of the component
  */
  _inherits(SelectList, _React$Component);
  return _createClass(SelectList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        isListElementRendered: false
      });
      if (nextProps.selectedValue !== this.props.selectedValue) {
        this.setState({
          hasValue: nextProps.selectedValue !== '-1' && nextProps.selectedValue !== ''
        });
      }
    }
  }, {
    key: "onSelectClick",
    value: function onSelectClick(e) {
      var _this2 = this;
      var dropdownMenu = e.currentTarget.closest('.select').querySelector('.dropdown-menu');
      new Promise(function (res, rej) {
        res(_this2.setState({
          isOpen: !_this2.state.isOpen
        }));
      }).then(function () {
        if (_this2.state.isOpen) {
          dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + "px";
        } else {
          dropdownMenu.style.maxHeight = null;
        }
      });
      if (this.props.items.length === 0) {
        this.setState({
          isListElementRendered: true
        });
      } else {
        this.setState({
          isListElementRendered: false
        });
      }
    }
  }, {
    key: "onSelectChange",
    value: function onSelectChange(e) {
      if (e.currentTarget.value !== '-1' && e.currentTarget.value !== '' && !this.props.addBlankItem) {
        var blankItem = e.currentTarget.querySelector("option[value='-1']");
        if (blankItem !== null) {
          blankItem.disabled = true;
          // blankItem.parentNode.removeChild(blankItem);
        }
      }
      this.props.onValueChange(e);
    }
  }, {
    key: "onCustomSelectChange",
    value: function onCustomSelectChange(e) {
      this.setState({
        isOpen: false
      });
      this.props.onValueChange(e);
      // added for iphone fix
      var dd = e.currentTarget.closest('.select').querySelector('.dropdown-menu');
      dd.style.maxHeight = null;
    }
  }, {
    key: "onSelectBlur",
    value: function onSelectBlur(e) {
      this.setState({
        isOpen: false
      });
      var dd = e.currentTarget.closest('.select').querySelector('.dropdown-menu');
      dd.style.maxHeight = null;
    }
  }, {
    key: "onSelectKeyUp",
    value: function onSelectKeyUp(e) {
      if (e.keyCode === 27) {
        this.setState({
          isOpen: false
        });
      }
    }
  }, {
    key: "lineThrough",
    value: function lineThrough(text) {
      text = "t".concat(text);
      var linedThroughText = text.split('').reduce(function (acc, char) {
        return "".concat(acc + char, "\u0336");
      }, '');
      return linedThroughText.substring(1);
    }
  }, {
    key: "renderSelectWithLabel",
    value: function renderSelectWithLabel() {
      if (this.props.addLabel) {
        if (this.props.showLabelOutside) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderCustomLabel(), this.renderCustomSelect());
        }
        return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderCustomSelect(), this.renderCustomLabel());
      }
      return this.renderCustomSelect();
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _this3 = this;
      var selectClasses = classNames({
        'has-value': this.state.hasValue,
        'has-error': this.props.hasError
      });
      return /*#__PURE__*/React.createElement("select", {
        value: this.props.selectedValue,
        className: selectClasses,
        id: this.props.id,
        onChange: function onChange(event) {
          return _this3.onSelectChange(event);
        },
        onClick: function onClick(event) {
          return _this3.onSelectClick(event);
        },
        onBlur: function onBlur(event) {
          return _this3.onSelectBlur(event);
        },
        onKeyUp: function onKeyUp(event) {
          return _this3.onSelectKeyUp(event);
        }
      }, this.renderBlankItem(), this.props.items.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          value: option.value || option.id,
          key: "select-list-".concat(_this3.id, "-").concat(option.value || option.id),
          className: classNames({
            'select-item-forceable': option.forceable
          })
        }, option.forceable ? _this3.lineThrough(option.text || option.name) : option.text || option.name);
      }));
    }
  }, {
    key: "renderCustomSelect",
    value: function renderCustomSelect() {
      var _this4 = this;
      var selectClasses = classNames({
        'select': true,
        'is-active': this.state.hasValue,
        'has-error': this.props.hasError
      });
      var listClasses = classNames({
        'has-value': this.state.hasValue,
        'has-error': this.props.hasError
      });
      var selectedItemText = this.props.items.find(function (x) {
        return String(x.value) === String(_this4.props.selectedValue);
      });
      return /*#__PURE__*/React.createElement("dl", {
        className: selectClasses,
        onBlur: function onBlur(event) {
          return _this4.onSelectBlur(event);
        }
      }, /*#__PURE__*/React.createElement("dt", null, /*#__PURE__*/React.createElement("button", {
        className: "btn",
        type: "button",
        onClick: function onClick(event) {
          return _this4.onSelectClick(event);
        },
        dangerouslySetInnerHTML: {
          __html: selectedItemText ? selectedItemText.text : ''
        },
        disabled: this.props.disabled
      })), /*#__PURE__*/React.createElement("dd", {
        className: "dropdown-menu option"
      }, /*#__PURE__*/React.createElement("ul", {
        className: listClasses
      }, this.state.isListElementRendered && /*#__PURE__*/React.createElement("li", {
        "data-null": true
      }, "---"), this.props.items.map(function (li) {
        return /*#__PURE__*/React.createElement("li", {
          value: li.value || li.id,
          "data-value": li.value || li.id // used to grab the correct value if using strings [li elements only use Integers for value]
          ,
          key: "select-list-".concat(_this4.id, "-").concat(li.value || li.id),
          className: classNames({
            'selected-item': String(li.value) === String(_this4.props.selectedValue),
            'forcible-option': li.forceable
          }),
          id: _this4.props.id,
          name: _this4.props.name,
          onMouseDown: function onMouseDown(event) {
            return _this4.onCustomSelectChange(event);
          }
        }, li.text || li.name);
      }))));
    }
  }, {
    key: "renderBlankItem",
    value: function renderBlankItem() {
      if (this.props.selectedValue === '-1' || this.props.selectedValue === '') {
        return /*#__PURE__*/React.createElement("option", {
          value: "-1"
        });
      } else if (this.props.addBlankItem) {
        return /*#__PURE__*/React.createElement("option", {
          value: "-1"
        });
      }
      return null;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: this.props.id
      }, " ", this.props.label, this.props.isRequired && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*"));
    }
  }, {
    key: "renderCustomLabel",
    value: function renderCustomLabel() {
      return /*#__PURE__*/React.createElement("span", null, " ", this.props.label, this.props.isRequired && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*"));
    }
  }, {
    key: "render",
    value: function render() {
      var divWrapperClasses = classNames({
        'wdh-feature-b2b-field': true,
        'form-field': true,
        'has-float-label': !this.props.showLabelOutside,
        'select-list': true,
        'is-open': this.state.isOpen,
        'show-float-label': this.props.showFloatLabel
      });
      return /*#__PURE__*/React.createElement("div", {
        className: divWrapperClasses,
        style: {
          display: this.props.display ? 'inline-block' : 'none'
        }
      }, this.renderSelectWithLabel());
    }
  }], [{
    key: "randomString",
    value:
    /**
    * Generate a random string
    * @param {Number} length Length of the random string
    */
    function randomString(length) {
      var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      var string = '';
      for (var r = 0; r < length; r += 1) {
        string += letters.charAt(Math.floor(Math.random() * letters.length));
      }
      return string;
    }
  }]);
}(React.Component);
SelectList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
    forceable: PropTypes.bool
  })).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onValueChange: PropTypes.func,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  display: PropTypes.bool,
  showHelpText: PropTypes.bool,
  helpTextHTML: PropTypes.string,
  hasError: PropTypes.bool,
  addBlankItem: PropTypes.bool,
  addLabel: PropTypes.bool,
  showLabelOutside: PropTypes.bool,
  isRequired: PropTypes.bool,
  showFloatLabel: PropTypes.bool,
  disabled: PropTypes.bool
};
SelectList.defaultProps = {
  label: '',
  id: "select-list-".concat(SelectList.randomString(4)),
  name: '',
  display: true,
  showHelpText: false,
  helpTextHTML: '&nbsp;',
  hasError: false,
  onValueChange: function onValueChange() {},
  addBlankItem: true,
  addLabel: true,
  showLabelOutside: false,
  isRequired: false,
  showFloatLabel: false,
  disabled: false
};
export default SelectList;